var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-tabs',{attrs:{"dark":"","slider-color":"red"}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:("tab-" + (tab.route)),attrs:{"ripple":"","to":{ name: tab.route }}},[_vm._v("\n      "+_vm._s(tab.name)+"\n    ")])}),1),_vm._v(" "),_c('v-card',{staticClass:"px-4 py-4"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-306c8f29","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Sponsors/Settings/index.vue
// module id = null
// module chunks = 